import Vue from 'vue';
import VueI18n from 'vue-i18n';
import localization from '@/services/localization';

Vue.use(VueI18n);

// Create a single, shared i18n instance
const i18n = new VueI18n(localization);

export default i18n;
